// extracted by mini-css-extract-plugin
module.exports = {"statsSection":"gridSection_statsSection__3VIR7"};